import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { asLlmTab, type LlmTab } from '@/features/ai/ai-href';
import { LlmGatewayPage } from '@/features/ai/llm/llm-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Administration → « Passerelle LLM » : modèles, budgets, journal (ADR 0080 §2). */
export const Route = createFileRoute('/$tenant/llm/')({
  validateSearch: (search: Record<string, unknown>): { tab: LlmTab } => ({ tab: asLlmTab(search['tab']) }),
  component: LlmGatewayRoute,
});

function LlmGatewayRoute() {
  const { tenant } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="llmGateway" crumbs={[{ label: t('nav.items.llmGateway') }]}>
      <LlmGatewayPage
        tenantId={tenant}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
